"use strict";
// @ts-ignore
try {
    self['workbox:precaching:7.2.0'] && _();
}
catch (e) { }
